export function setGridSettings(state) {
  if (!state.grid_settings) return
  localStorage.setItem('grid_settings', JSON.stringify(state.grid_settings))
}

export function getGridSettings() {
  const templates = localStorage.getItem('grid_settings') || "{}"
  return { grid_settings: JSON.parse(templates) }
}
